import React from "react"
import DeleteFilter from "../../../../assets/iconos/close.svg";
import { latest as API_URL } from "../../../../config/api";
import ReactEcharts from "echarts-for-react";
import { barChart } from "../widgets/Charts";
import Helpers, { windowsActive, number_format } from "../../../../config/Helpers";
import axios from "axios";
import { Icon, Tabs } from 'antd';

const postUrlLogin = API_URL + "widgets";

class FutureReserves extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            array_colors : ["#fec400", "#ff7d4d", "#ff4558", "#15d39a"],
            table_result : {
                years : (<div></div>),
                months : (<div></div>),
                list : (<div></div>),
                list_months : (<div></div>),
                total_months : (<div></div>),
                total_all : (<div></div>)
            }
        }
        this.getOptionTypeBar   = this.getOptionTypeBar.bind(this);
    }

    getOptionTypeBar = (chart) => {
        
        let char_keys = Object.keys(this.props.response_request);
        let legends = [], xAxis = [], series = [];
        let self = this;
        let result
        if (char_keys.length > 0){
            result    = this.props.response_request["result"][chart];
            if(chart !== "data_adv_booking_intervals"){
                Object.keys(result).map(function(key){
                switch (key) {
                    case "legends":
                        legends = result[key];
                        break;
                
                    case "xAxis":
                        xAxis = result[key];
                        break;
                    
                    case "series":
                        series = Object.keys(result[key]).map(function(key_serie, index){
                            return {
                                name: key_serie,
                                color: self.state.array_colors[index],
                                type: "bar",
                                data: result[key][key_serie],
                                stack : "Market"
                            }
                        })
                        break;
                    }
                })
            }
        }
        return barChart("280px", legends, xAxis, series, self.props.view_results, this.props.current_year, this.props.past_year, '85px')
    }
    componentWillReceiveProps(props){
        let char_keys = Object.keys(this.props.response_request);
        let self = this;
        let result
        let type_value = self.props.view_results !== "room_night" ? "$" : "";
        let table_result = {
            years : (<div></div>),
            months : (<div></div>),
            list : (<div></div>),
            list_months : (<div></div>),
            total_months : (<div></div>),
            total_all : (<div></div>)
        }
        if (char_keys.length > 0){
            var total_months = {};
            var total_all = 0;
            result  = self.props.response_request["result"]["data_reserves_to_future"];

            if(Object.keys(result).length > 0){   
                table_result.years = Object.keys(result["legends"]).map( (key_serie, index) =>
                    <div className={"column-grid " + (index % 2 ? "row-c" : "")}>
                        <div className="row-grid">{result["legends"][key_serie]}</div>
                    </div>
                );

                Object.keys(result["xAxis"]).map((key, index) => {
                    total_months[index] = 0;
                })
                table_result.months = Object.keys(result["xAxis"]).map( (key_serie) =>
                    <span className="row-grid to-future">{result["xAxis"][key_serie]}</span>
                );
                table_result.list = Object.keys(result["data_table"]).map( (key_serie, index) =>  
                    <div className={"column-grid " + (index % 2 ? "row-c" : "")}>
                        { 
                            Object.keys(result["data_table"][key_serie]).map( (key_month, index_month) =>  
                                {
                                    if(key_month != "1000"){
                                        total_months[key_month] += result["data_table"][key_serie][key_month];
                                        return <div className="row-grid to-future">{type_value + number_format(result["data_table"][key_serie][key_month])}</div>
                                    }else{
                                        total_all += result["data_table"][key_serie][key_month];
                                    }
                                }
                                
                            ) 
                        }
                    </div>
                );
                table_result.list_months = Object.keys(result["data_table"]).map( (key_serie, index) =>  
                    <div className={"column-grid " + (index % 2 ? "row-c" : "")}>
                        <div className="row-grid to-future">{key_serie}</div>
                        <div className="row-grid to-future">{number_format(result["data_table"][key_serie]["1000"])}</div>
                    </div>
                );
                table_result.total_months = Object.keys(total_months).map( (key_serie, index) =>  
                    <div className="row-grid">{number_format(total_months[key_serie])}</div>
                );
                table_result.total_all = <div className="row-grid">{number_format(total_all)}</div>;
            }
            this.setState({
                table_result : table_result
            })
        }
    }
    render() {
        let request_send = this.props.app.state.leadtime_module.request_send;
        return (
            <section>
                {
                    (request_send === true) ? (
                    <div className="load-submodule">
                        <Icon type="loading" />
                    </div>) : ""
                }
                <div className={"datagrid-widget reserves-to-future"}>
                    <div className="container-fluid">
                        <div className="row header-widget">
                            <div className="col-md-12 options-widget">
                                <span className="title">ADVANCE BOOKING - {this.props.current_year}</span>
                                
                                <span className="opt remove-widget hide">
                                    <img src={DeleteFilter} />
                                </span>
                            </div>
                        </div>
                        <div className="current-values">
                            <div className="row">
                                
                            </div>
                            <div className="row">
                                <div className="col-md-12 datagrid-list">
                                <ReactEcharts
                                    option={ windowsActive(this.props, "lead-time", "future_reserves") === true ? this.getOptionTypeBar("data_reserves_to_future") : {}}
                                    notMerge={true}
                                    lazyUpdate={true}
                                    style={{height : '380px'}}
                                    theme={"theme_name"}
                                    opts={{renderer: 'svg'}}
                                    onChartReady={this.onChartReadyCallback}
                                />
                                </div>
                            </div>
                        </div>   
                    </div>
                </div>
                {
                    (request_send === true) ? (
                    <div className="load-submodule">
                        <Icon type="loading" />
                    </div>) : ""
                }
                <div className="col-md-2 no-padding-left-right">
                    <div className={"datagrid-widget"}>
                        <div className="container-fluid no-padding-right">
                            <div className="current-values">
                                <div className="row no-margin-left-right">
                                    <div className="col-md-12 head-current">
                                        <span className="row-grid to-future">MONTHS</span> 
                                        <span className="row-grid to-future">TOTAL</span> 
                                    </div>
                                    <div className="col-md-12 datagrid-list">
                                        {this.state.table_result.list_months}
                                        <div className={"column-grid totals"}>
                                            <div className="row-grid">TOTAL</div>
                                            {this.state.table_result.total_all}
                                        </div>
                                    </div>
                                </div>
                            </div>   
                        </div>
                    </div>
                </div>
                <div className="col-md-10 no-padding-left-right">
                    <div className="scroller-section">
                        <div className={"datagrid-widget list-result-years"}>
                            <div>
                                <div className="current-values">
                                    <div>
                                        <div className="col-md-12 head-current">
                                            {this.state.table_result.months}
                                        </div>
                                    </div>
                                    <div>
                                        <div className="col-md-12 datagrid-list">
                                            {this.state.table_result.list}
                                            <div className={"column-grid totals"}>
                                                {this.state.table_result.total_months}
                                            </div>
                                        </div>
                                    </div>
                                </div>   
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default FutureReserves



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/lead-time/views/FutureReserves.js